// src/utils/claimHelpers.js
// La migración masiva de datos dejó "5000" como crmClaimId por defecto en
// los reclamos que nunca se volvieron a tocar después — ese link no apunta
// a un reclamo real, así que no hay cheque ni respaldo que mostrar.
// Compartido entre ClaimsDirectory.jsx (vista de ajustadores) y
// Dashboard.jsx (badge de recordatorio para admin).
const DEFAULT_CRM_CLAIM_ID = '5000';

export const hasRealCrmLink = (claim) => {
  const id = claim.crmClaimId != null ? String(claim.crmClaimId).trim() : '';
  return id !== '' && id !== DEFAULT_CRM_CLAIM_ID;
};

// Enlace a Organized Adjusting armado SIEMPRE desde crmClaimId (nunca se usa
// un `crmLink` guardado: es texto editable y podría traer un esquema como
// javascript:). El id va codificado para que no pueda salir de la ruta.
export const crmLinkFor = (claim) => {
  if (!hasRealCrmLink(claim)) return '';
  return `https://app.organizedadjusting.com/app/claims/${encodeURIComponent(String(claim.crmClaimId).trim())}`;
};

// Un respaldo puede existir en el CRM histórico o en el almacenamiento
// privado nuevo de Hostinger.
export const hasCheckBackup = (claim) => {
  return Boolean(claim?.checkAttachment?.storageKey) || hasRealCrmLink(claim);
};

// Un cheque está listo para cobrar la comisión cuando tiene los valores
// reales confirmados y el backup del cheque. Única definición — la usan
// checkStage() en ClaimsDirectory.jsx, el cobro dentro del cheque
// (CsrCollection.jsx) y la migración. (La confirmación de Organized
// Adjusting se quitó el 2026-09-24.)
export const isCheckReadyForPayment = (check) => {
  return Boolean(check?.realValuesConfirmed && check?.checkAttachment?.storageKey);
};

// Deep link a la web de Google Voice (voice.google.com) con el número
// precargado para marcar — Google Voice NO tiene API pública para
// terceros (a diferencia de Calendar), así que esto es lo único posible
// sin backend/credenciales: abre la pestaña de Voice del propio ajustador
// con el número ya listo, en vez de intentar originar la llamada desde acá.
// "a=nc,<número>" es el mismo patrón de URL que usa la propia UI de Voice
// para "nueva llamada". Requiere el número en formato E.164 (+1XXXXXXXXXX
// para EE.UU.) — se asume EE.UU. si no trae código de país, que es el caso
// de todos los teléfonos de cliente en esta app.
export const googleVoiceCallLink = (phone) => {
  const digits = String(phone || '').replace(/[^\d+]/g, '');
  if (!digits) return null;
  const e164 = digits.startsWith('+') ? digits : `+1${digits.replace(/^1/, '')}`;
  return `https://voice.google.com/u/0/calls?a=nc,${encodeURIComponent(e164)}`;
};

// Filtro por paso del reclamo, compartido por la lista de reclamos y la de
// comisiones. stepFilter: 'all' | 'none' (sin paso) | 'phase:N' | stepId.
export const matchesStepFilter = (record, stepFilter) => {
  if (!stepFilter || stepFilter === 'all') return true;
  const stepId = record?.flow?.stepId;
  if (stepFilter === 'none') return !stepId;
  if (!stepId) return false;
  if (stepFilter.startsWith('phase:')) return String(record.flow.phase) === stepFilter.slice(6);
  return stepId === stepFilter;
};
